import React from "react";
import { seoUrl } from "../../lib/helpers";

import * as styles from "../../styles/components/product/feature-overview.module.css";
import SectionHeader from "../product-section-header";
import Container from "../container";
import FeatureGrid from "./feature-grid";

const FeatureOverview = (props) => {
  const { title,caption,features,position } = props;
  return (
    <div className={styles.root} id={caption ? seoUrl(caption) : undefined}>
      {title && (
        <SectionHeader
          title={title}
          subtitle={caption}
          position={position}
        />
      )}
      <Container>
        <FeatureGrid features={features}/>
      </Container>
    </div>
  );
};

export default FeatureOverview;
